import type { ProductByProductModelId } from "@/utils/magento/get-products-by-product-model-ids";

const normalizeSku = (sku?: string | null) => (sku ?? "").trim().toLowerCase();

// Groups the products by product_model_id; one model id can map to several SKUs
// (e.g. TS400HT-6 and its "-6-Heat" / "-6-Heat&Lights" variants).
export const groupProductsByModelId = (
  products: ProductByProductModelId[],
): Map<string, ProductByProductModelId[]> => {
  const grouped = new Map<string, ProductByProductModelId[]>();
  for (const product of products) {
    const modelId = String(product.product_model_id);
    grouped.set(modelId, [...(grouped.get(modelId) ?? []), product]);
  }
  return grouped;
};

// Prefers the product whose SKU matches the pricing item, then the first one that has the field
export const findProductForItem = (
  itemSku: string,
  products: ProductByProductModelId[],
  hasValue: (product: ProductByProductModelId) => unknown,
): ProductByProductModelId | undefined => {
  const withValue = products.filter((product) => hasValue(product));
  return (
    withValue.find((product) => normalizeSku(product.sku) === normalizeSku(itemSku)) ??
    withValue[0]
  );
};
